import { Card, Grid, styled, useTheme, Box } from '@mui/material';
import { Fragment, useState, useRef, useEffect } from 'react';
import DoughnutChart from './shared/Doughnut';
import StatCards from './shared/StatCards';
import TopSellingTable from './shared/TopSellingTable';
import PresentEmployeesTable from './shared/PresentEmployee';
import AbsentEmployeesTable from './shared/AbsentEmployee';
import EmployeesOnLeaveTable from './shared/EmployeeOnLeave';
import EmployeeLeaveWeek from './shared/EmployeeLeaveWeek';
import Header from '../../../../components/Header';
import LeaveAwaitingApprovalTable from './shared/LeaveAwaitingApprovalTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' },
}));

const Analytics = () => {
  const { palette } = useTheme();

  const [activeTable, setActiveTable] = useState(null); // Track active table
  const [employeeData, setEmployeeData] = useState({
    presentEmployees: [],
    absentEmployees: [],
    pendingApplications: [],
  });

  const tableRef = useRef(null);
  const graphRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tableRef.current && !tableRef.current.contains(event.target)) {
        setActiveTable(null); // Hide the table when clicked outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

useEffect(() => {
  const fetchData = async () => {
    const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;

    try {
      const [appResponse, presentResponse, absentResponse] = await Promise.all([
        fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application`, {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        }),
        fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/present-employees`, {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        }),
        fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/absent-employees`, {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        })
      ]);

      const appData = await appResponse.json();
      const presentData = await presentResponse.json();
      const absentData = await absentResponse.json();

      setEmployeeData({
        presentEmployees: presentData.present_employees,
        absentEmployees: absentData.absent_employees,
        pendingApplications: appData.filter(item => item.ApplicationStatus === 'PENDING'),
      });
    } catch (error) {
      console.error('Error fetching employee data:', error);
    }
  };

  fetchData();
}, []);

  const handleTableClick = (tableName) => {
    if (activeTable === tableName) {
      setActiveTable(null); // Hide if clicked again
    } else {
      setActiveTable(tableName); // Show selected table
    }
  };

  return (
    <Fragment>
      <ContentBox className="analytics">
        <Header title="Dashboard Admin" subtitle="Welcome to Admin dashboard" />

        {/* Layout Grid */}
        <Grid container spacing={3}>

          <Grid item lg={8} md={8} sm={12} xs={12}>
            {/* Stat Cards */}
            <StatCards 
              setActiveTable={setActiveTable} 
              employeeData={employeeData} 
            />
            {/* Present and Absent Employees Table */}
            <Box ref={tableRef} sx={{ width: '100%', mt: 0, pt: 0 }}>
              {activeTable === 'presentEmployees' && (
                <PresentEmployeesTable employees={employeeData.presentEmployees} />
              )}
              {activeTable === 'absentEmployees' && (
                <AbsentEmployeesTable employees={employeeData.absentEmployees} />
              )}
              {activeTable === 'totalEmployees' && (
                <TopSellingTable />
              )}
              {activeTable === 'leaveAwaitingApproval' && (
                <LeaveAwaitingApprovalTable applications={employeeData.pendingApplications} />
              )}
            </Box>
          </Grid>

          {/* RIGHT SIDE (Graph) */}
          <Grid item lg={4} md={4} sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Card sx={{ px: 3, py: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: "white", height: '100%' }}>
              <span style={{ color: 'black', fontSize: '1rem', fontWeight: '500' }}>Total Leaves Taken</span>
              <span style={{ color: 'black', fontSize: '0.875rem' }}>Current Year</span>
              <DoughnutChart
                height={activeTable ? '40%' : '100%'} // Adjust graph size based on table visibility
                color={[palette.primary.dark, palette.primary.main, palette.primary.light]}
              />
            </Card>
          </Grid>
        </Grid>

        {/* Tables below the Stat Card */}
        
        <Grid container spacing={3} sx={{ mt: 3 }}>
  <Grid item lg={6} md={6} sm={12} xs={12}>
    <EmployeesOnLeaveTable />
  </Grid>
  <Grid item lg={6} md={6} sm={12} xs={12}>
    <EmployeeLeaveWeek />
  </Grid>
</Grid>


      </ContentBox>
    </Fragment>
  );
};

export default Analytics;
